import React, { Children } from 'react';
import classlist from 'utils/classlist';
import './style.scss';

interface CardProp {
    className?: string;
    children?: React.ReactNode;
    form?: boolean; // 表单模式
    page?: boolean; // 单个page模式
}

const Card: React.FC<CardProp> = ({ className, form, page, children }) => {
    return (
        <div className={classlist('comp-card', className, { 'comp-card-form': form, 'common-page': page })}>
            {children}
        </div>
    );
};

// card 底部按钮，支持多个按钮
export const CardButtonWrap: React.FC<{ children: React.ReactNode; className?: string }> = ({
    children,
    className
}) => {
    const count = Children.toArray(children).length;

    return (
        <div className={classlist('comp-card-btn-wrap', { 'card-btn-multi': count > 1 }, className)}>{children}</div>
    );
};

export default Card;
